import moment from 'moment';

const formatDate = function(date) {
  if (!date) return null;

  return moment(date).format('DD/MM/YYYY');
};

const formatDateTime = function(date) {
  if (!date) return null;

  return moment(date).format('DD/MM/YYYY HH:mm');
};

const formatDateTimeSecond = function(date) {
  if (!date) return null;

  return moment(date).format('DD/MM/YYYY HH:mm:ss');
};

const formatTime = function(date) {
  if (!date) return null;

  return moment(date).format('HH:mm');
};


const isNew = function(date,minute) {
  if (!date) return false;
	if (!minute) return false;
	var duration = moment.duration({ 'minutes': minute });
	var limite = moment().subtract(duration);
	var dateMoment = moment(date);
	if (dateMoment >= limite)  {
		return true;
	}
  return false;
};




const displayTime = function(value, showTrailingZeroes = false) {
  if (value === null || isNaN(value)) {
		return null;
	}

	value = Math.round(value);
	if (value < 0) {
		value = 0;
	}

	let timeLeft = [], temp;
	if (value >= 3600) {
		temp = Math.floor(value / 3600);
		if (temp > 0) {
			timeLeft.push(temp + "h");
			value = value % 3600;
		}
	}
	if (value >= 60) {
		temp = Math.floor(value / 60);
		if (temp > 0) {
			timeLeft.push(((value > 9 || !showTrailingZeroes) ? temp : "0" + temp) + "min");
			value = value % 60;
		}
	}
	value = value.toFixed(0);
	if(value != 0) {
		timeLeft.push(((value > 9 || !showTrailingZeroes) ? value : "0" + value) + "s");
	}
	

	return timeLeft.join(' ');
};

export { formatDateTimeSecond,formatDateTime,formatDate,formatTime, displayTime, isNew };
